document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('.slider-mobile-gutter.enable-swipe');

  function updateSliderBehavior() {
    sliders.forEach(slider => {
      if (window.innerWidth >= 750) {
        // Disable slider for desktop
        slider.classList.remove('enable-swipe');
        slider.style.overflow = 'visible';
      } else {
        // Enable slider for mobile
        slider.classList.add('enable-swipe');
        slider.style.overflow = 'hidden';
      }

      // Reinitialize slider if necessary (adjust based on your slider library)
      if (typeof initializeSlider === 'function') {
        initializeSlider(slider);
      }
    });
  }

  // Initial check
  updateSliderBehavior();

  // Update on window resize
  window.addEventListener('resize', updateSliderBehavior);
});

// Example slider initialization function (adjust based on your slider library)
function initializeSlider(slider) {
  if (slider.swiper) {
    slider.swiper.destroy();
  }
  if (slider.classList.contains('enable-swipe')) {
    new Swiper(slider, {
      // Swiper options
    });
  }
}